import { render, staticRenderFns } from "./CompanyEditDetailsTab.vue?vue&type=template&id=43a780c8"
import script from "./CompanyEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./CompanyEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports